interface Number {
    toFixedEpsilon(toFix?: number): number;
}

Number.prototype.toFixedEpsilon = function(this: number, toFix?: number)  {
    const toDecimal = Math.pow(10, toFix ?? 2);
    return Math.round((this + Number.EPSILON) * toDecimal) / toDecimal;
};
